module.exports = __webpack_public_path__ + "front/img/edm-bj.0019d108.png";